export const MessageViewSkeleton = () => {
  const shimmer: React.CSSProperties = {
    background: "linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    animation: "skeletonShimmer 1.5s ease-in-out infinite",
  };

  const bubbles = [
    { outgoing: false, width: "52%", height: 145 },

    { outgoing: true, width: "52%", height: 175 },
    { outgoing: false, width: "44%", height: 130 },
    { outgoing: true, width: "63%", height: 155 },
    // { outgoing: false, width: "38%", height: 38 },
    // { outgoing: true, width: "57%", height: 52 },
    // { outgoing: false, width: "48%", height: 38 },
    // { outgoing: false, width: "48%", height: 38 },
  ];

  return (
    <div style={{ flex: 1, background: "#fff", display: "flex", flexDirection: "column", minWidth: 0 }}>
      <div
        style={{
          flex: 1,
          padding: "24px 32px",
          display: "flex",
          flexDirection: "column",
          gap: 18,
          background: "#fafafa",
          overflow: "hidden",
        }}
      >
        {bubbles.map((b, i) => (
          <div key={i} className="flex flex-col" style={{ alignItems: b.outgoing ? "flex-end" : "flex-start" }}>
            {/* Bubble */}
            <div
              style={{
                ...shimmer,
                height: b.height,
                width: b.width,
                borderRadius: b.outgoing ? "14px 14px 4px 14px" : "14px 14px 14px 4px",
              }}
            />
            {/* Timestamp + via label */}
            <div className="flex items-center gap-2 mt-[5px]">
              <div style={{ ...shimmer, height: 8, width: 80, borderRadius: 4 }} />
              <div style={{ ...shimmer, height: 8, width: 48, borderRadius: 4 }} />
            </div>
          </div>
        ))}
      </div>

      {/* Composer toggle skeleton */}
      <div
        className="shrink-0 flex justify-center items-center"
        style={{ padding: "9px 0", borderTop: "1px solid #e5e7eb", background: "#fff" }}
      >
        <div style={{ ...shimmer, height: 28, width: 90, borderRadius: 99 }} />
      </div>

      <style>{`
        @keyframes skeletonShimmer {
          0%   { background-position:  200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </div>
  );
};
